<template>
  <div>
    <a-form-model-item v-show="expand" :rules="{required:true}">
      <a-tree-select
        v-model="bugStatus"
        show-search
        :disabled="isMaintainer===0 && problemData.isHandler ===0"
        :filter-tree-node="filterModule"
        :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
        style="width: 100%"
        :tree-data="tagList"
        @change="handleChange()"
      />
    </a-form-model-item>
  </div>
</template>
<script>
import { modifyTicketFlag } from '@/api/event/problem';

export default {
  components: { },
  props: {
    status: {
      type: [String, Number],
      default: null
    },
    tagList: {
      type: Array,
      default: null
    },
    isMaintainer: {
      type: Boolean,
      default: false
    },
    ticketId: {
      type: [String, Number],
      default: null
    },
    flag: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      bugStatus: null,
      expand: true
    };
  },
  computed: {
    projectId() {
      return parseInt(this.$route.params.project_id) || this.project_id;
    }
  },
  mounted() {
    this.bugStatus = this.status;
  },
  methods: {
    handleChange() {
      //   this.$refs.ticketStatusChangeModal.open(this.status, value);
      this.updateStatusAndComment();
    },
    filterModule(searchValue, treeNode) {
      return treeNode.data.props.title.includes(searchValue);
    },
    updateStatusAndComment() {
      const req = {
        'id': this.ticketId,
        'handler': '',
        'maintainer': '',
        'tags': '',
        'level': '',
        'status': '',
        'domain': ''

      };

      if (this.flag === 'status') {
        req.status = this.bugStatus;
      }
      if (this.flag === 'handler') {
        req.handler = this.bugStatus;
      }
      if (this.flag === 'maintainer') {
        req.maintainer = this.bugStatus;
      }
      if (this.flag === 'tags') {
        req.tags = this.bugStatus;
      }
      if (this.flag === 'level') {
        req.level = this.bugStatus;
      }
      if (this.flag === 'domain') {
        req.domain = this.bugStatus;
      }
      modifyTicketFlag({ req }).then(() => {
        this.$emit('callback');
      });
    }
  }
};
</script>

      <style lang="less" scoped>
      .issue-status {
        cursor: pointer;
        display: inline-block;
        padding: 2px;
        padding-right: 2px;
        line-height: 22px;
        border-radius: 4px;
        .ant-tag {
          margin-right: 2px;
        }
        .icon-down {
          opacity: 0;
        }
      }

      .edit-status:hover {
        cursor: pointer;
        background-color: #e4e4e4;
        .icon-down {
          opacity: 1;
        }
      }
      </style>

